export enum ConsentActionType {
  CHECKED_VERIFY_PHONE = "CHECKED_VERIFY_PHONE",
  ACCEPTED_VERIFY_PHONE = "ACCEPTED_VERIFY_PHONE",
  CHECKED_CONSENT = "CHECKED_CONSENT",
  ACCEPTED_AND_SCAN = "ACCEPTED_AND_SCAN",
  REJECTED_EKYC = "REJECTED_EKYC",
}
